import React from 'react';
import CustomButton from './customButton/CustomButton';

function DonateCauseBox({ title, body, buttonTitle }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 10px',
        flex: 1,
      }}>
      <div style={{ fontSize: 36 }}>{title}</div>
      <div style={{ fontSize: 16, marginBottom: 24 }}>{body}</div>
      <div>
        <CustomButton name={`DONATE ₹ ${buttonTitle}`} />
      </div>
    </div>
  );
}

export default DonateCauseBox;
